// Jun 2026 · Branded route-transition skeleton for the React.lazy Suspense
// boundary (replaces the plain "Loading…" text). Mimics the app shell — nav
// bar, page header, card grid — so navigation feels instant, not broken.
export default function SuspenseFallback() {
  return (
    <div className="min-h-screen bg-white" data-testid="lazy-route-fallback">
      <span className="sr-only">Loading…</span>
      <div className="h-16 border-b border-neutral-200 flex items-center justify-between px-6 lg:px-10">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-neutral-200 animate-pulse" />
          <div className="font-display font-black tracking-tighter text-sm text-neutral-300 uppercase">
            Three Little Birds
          </div>
        </div>
        <div className="flex items-center gap-3">
          <div className="h-4 w-20 bg-neutral-100 animate-pulse" />
          <div className="h-4 w-16 bg-neutral-100 animate-pulse" />
          <div className="w-8 h-8 rounded-full bg-neutral-200 animate-pulse" />
        </div>
      </div>
      <main className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
        <div className="h-3 w-28 bg-[#7C5FB0]/20 animate-pulse mb-4" />
        <div className="h-12 w-72 max-w-full bg-neutral-200 animate-pulse mb-3" />
        <div className="h-4 w-96 max-w-full bg-neutral-100 animate-pulse mb-10" />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {[0, 1, 2].map((i) => (
            <div key={i} className="border border-neutral-200 p-5">
              <div className="h-3 w-16 bg-neutral-100 animate-pulse mb-3" />
              <div className="h-6 w-3/4 bg-neutral-200 animate-pulse mb-2" />
              <div className="h-3 w-full bg-neutral-100 animate-pulse" />
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}
